import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageGridContainerComponent } from './page-grid-container.component';
import { CmsConfig, I18nModule, provideConfig } from '@spartacus/core';
import { RouterModule } from '@angular/router';
import { PaginationModule } from '@spartacus/storefront';
import { LocalLoaderComponent } from '../../../../../../components/loader/local-loader/local-loader.component';

@NgModule({
  declarations: [PageGridContainerComponent],
  imports: [CommonModule, I18nModule, RouterModule, PaginationModule, LocalLoaderComponent],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        PageGridContainer: {
          component: PageGridContainerComponent,
        },
      },
    }),
  ],
})
export class PageGridContainerModule {}
